export function isCustomerInvoiceExcluded(user, customerId) {
    const id = Number(customerId);
    if (!Number.isFinite(id) || id <= 0) return false;

    const excludedCustomerIds = (user && user.invoiceExcludedCustomerIds) || [];
    return excludedCustomerIds.some((excludedId) => Number(excludedId) === id);
}



// WEBPACK FOOTER //
// app/utils/customerInvoiceExclusions.js